import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { mobileAndTabletCSS } from '@measures/responsive'
import useClientViewportType from '@hooks/useClientViewportType'
import useIsInUltraModuleBundling from '@hooks/useIsInUltraModuleBundling'

interface RelatedItemsSidebarWrapperProps {
  children?: ReactNode
  accentColor?: string
}

const StyledRelatedItemsSidebarWrapper = styled.div<
  Pick<RelatedItemsSidebarWrapperProps, 'accentColor'>
>`
  ${({
    theme: {
      spacing: { spacing16 },
    },
  }) => css`
    ${mobileAndTabletCSS(css`
      display: none;
    `)}

    display: grid;
    grid-row-gap: ${spacing16};
    align-items: flex-start;

    padding-top: ${spacing16};
  `}
`

const RelatedItemsSidebarWrapper: FunctionComponent<
  RelatedItemsSidebarWrapperProps
> = ({ children, accentColor }) => {
  const hasBundling = useIsInUltraModuleBundling()

  if (!['server', 'desktop'].includes(useClientViewportType()) || !children) {
    return null
  }
  if (!hasBundling) {
    return children
  }

  return (
    <StyledRelatedItemsSidebarWrapper accentColor={accentColor}>
      {children}
    </StyledRelatedItemsSidebarWrapper>
  )
}

export default RelatedItemsSidebarWrapper
